import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PreferencesService } from 'src/app/services/preferences.service';
import { AuthService } from 'src/app/services/auth.service';
declare var $ : any;
@Component({
  selector: 'app-height-list',
  templateUrl: './alcohol-list.component.html',
  styleUrls: ['./alcohol-list.component.css']
})
export class AlcoholConsumptionComponent implements OnInit {
  token: any;
  heightList: any;
  p: any = 1;
  count: any = 0;
  total: any = 10;
  id: any;
  searchText: any = '';
  sideStatus: any;
  isChecked: any;
  heightId: any = [];
  masterSelected: boolean = false;
  exportList: any;

  constructor(    public router: Router,
    private prefrencesService: PreferencesService,
    private toastr : ToastrService,
    private authService: AuthService,
    private activateroute: ActivatedRoute) { }

  public get isManager(): boolean {
    return this.authService.isManager;
  }

  ngOnInit(): void {
    this.alcoholListing();
  }

  alcoholListing() {
    let offset = this.p - 1;
    if(this.searchText != '')
    {
      offset = 0;
    }
    let obj = {
      limit: 10,
      offset: offset,
      search: this.searchText,
    };
    
    this.token = localStorage['token'];
    this.prefrencesService.alcoholList(obj,this.token).subscribe((res: any) => {
      if (res && res.status == 200) {
        this.heightList =  res.data.data;
        this.count = res.data.total_count;
      }
      else if (res.status == 400 && res.message == "Please provide valid token") {
        // this.toastr.error(res.message);
        this.router.navigate(['/login']);
      }
      else{
        // this.toastr.success(res.message);
        alert(res.message);
      }
    });
  }

  checkSearchString() {
    if (!this.searchText) {
      // return this.stopSearchLoader();
    }
    this.alcoholListing()
   }

   stopSearchLoader() {
    $('.lds-ring').css('display', 'none');
  }

  searchTextFilter() {
    this.alcoholListing()
  }

  openModal(item: any){
    this.id = item.id;
  }

  deletePop(){
    let obj = {
      id: this.id,
    };
    console.log(obj)
    this.prefrencesService
      .alcoholConsumptionDelete(obj, this.token)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.toastr.success(res.message);
          $('#deletModal').modal('hide');
        } else if (res.status == 500) {
          this.toastr.success(res.message);
        }
        this.alcoholListing();
      });
  }

  onTableDataChange(event: any) {
    this.p = event;
    this.masterSelected = false;
    this.heightId = [];
    this.alcoholListing();
  }

}
